"use client";

import styled from "styled-components";
import LocationIcon from "/public/assets/icons/location-ico.png";
import { SIZES } from "@/components/constants";
import React, {useEffect, useRef} from "react";
import Button from "@/components/common/Button";
import {useMediaQuery} from "react-responsive";

const COMPANY_COORD = {
    lat: 37.488,
    lng: 127.122,
};
const NAVER_MAP_URL =
    "https://map.naver.com/p/entry/place/34337233?placePath=/home?from=map&fromPanelNum=1&additionalHeight=76&timestamp=202511251706&locale=ko&svcName=map_pcv5&c=15.00,0,0,0,dh";
const LocationMap = () => {
    const mapRef = useRef(null);
    const mapInstanceRef = useRef(null);
    const markerRef = useRef(null);
    const isTablet = useMediaQuery({
        query: `(max-width: ${SIZES.TABLET})`
    });
    const initMap = () => {
        if (typeof window === "undefined") return;
        if (!window.naver || !window.naver.maps) return;
        if (!mapRef.current) return;
        if (mapInstanceRef.current) return;
        const { naver } = window;
        const center = new naver.maps.LatLng(COMPANY_COORD.lat, COMPANY_COORD.lng);
        const map = new naver.maps.Map(mapRef.current, {
            center,
            zoom: 16,
        });
        mapInstanceRef.current = map;
        markerRef.current = new naver.maps.Marker({
            position: center,
            map,
        });
    };

    useEffect(() => {
        if (typeof window === "undefined") return;

        const handleReady = () => {
            initMap();
        };

        if (window.__NAVER_MAPS_READY__) {
            // 이미 레이아웃에서 스크립트 로드 끝난 상태
            initMap();
        } else {
            // 아직이면 이벤트 기다렸다가 실행
            window.addEventListener("naver-maps-ready", handleReady);
        }

        return () => {
            window.removeEventListener("naver-maps-ready", handleReady);
            // 필요하면 cleanup
            mapInstanceRef.current = null;
            markerRef.current = null;
        };
    }, []);

    return (
        <LocationMapWrap>
            {/*<Script*/}
            {/*    src={`https://oapi.map.naver.com/openapi/v3/maps.js?ncpKeyId=${NAVER_CLIENT_ID}`}*/}
            {/*    strategy="afterInteractive"*/}
            {/*    onReady={() => setScriptLoaded(true)}*/}
            {/*/>*/}
            <div className="map-inner" ref={mapRef} />
            <div className="map-info">
                <div className="info-wrap">
                    <div className="title">
                        <h2>웅비메디텍</h2>
                    </div>
                    <Button
                        type={`${!isTablet ? "solid" : "fill"}`}
                        size={`${!isTablet ? "l" : "m"}`}
                        round={true}
                        // brand={true}
                        text={"View Map"}
                        onClickFunc={async () => {
                            if (typeof window === "undefined") return; // SSR 방지용
                            window.open(NAVER_MAP_URL, "_blank", "noopener,noreferrer");
                        }}
                    />
                </div>
                <div className="address">
                    <div className="loc-ico">
                        <img src={LocationIcon?.src} alt="위치 아이콘" />
                    </div>
                    <p className="text">
                        서울특별시 송파구 송파대로 201. 테라타워2 A동 1113호 (문정동)
                    </p>
                </div>
            </div>
        </LocationMapWrap>
    );
};

const LocationMapWrap = styled.div`
  padding: 40px 0 180px;
  max-width: 1280px;
  margin: 0 auto;
  .map-inner {
    width: 100%;
    height: 600px;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .map-info {
    margin-top: 40px;
    .info-wrap {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .title {
        h2 {
          font-weight: 700;
          font-size: 48px;
          line-height: 58px;
          letter-spacing: -0.02em;
          color: #4939b1;
        }
      }
      .btn-wrap {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 133px;
        height: 56px;
        background: #ffffff;
        border: 2px solid #564f67;
        border-radius: 8px;
        cursor: pointer;
        p {
          font-weight: 600;
          font-size: 18px;
          letter-spacing: 0.02em;
          color: #564f67;
        }
      }
    }
    .address {
      margin-top: 40px;
      display: flex;
      align-items: center;
      gap: 10px;
      .loc-ico {
        width: 20px;
        flex-shrink: 0;
      }
      .text {
        font-weight: 700;
        font-size: 24px;
        line-height: 38px;
        color: #000000;
      }
    }
  }
  @media (max-width: ${SIZES.TABLET}) {
    padding: 40px 16px 80px;
    max-width: 100%;
    width: 100%;
    margin: 0 auto;
    .map-inner {
      height: 414px;
    }
    .map-info {
      margin-top: 24px;
      .info-wrap {
        .title {
          h2 {
            font-size: 18px;
            line-height: 28px;
          }
        }
        .btn-wrap {
          width: 90px;
          height: 28px;
          background: #23203b;
          border-radius: 4px;
          p {
            font-weight: 600;
            font-size: 14px;
            line-height: 18px;
            letter-spacing: 0.02em;
            color: #ffffff;
          }
        }
      }
      .address {
        margin-top: 10px;
        .loc-ico {
          display: none;
        }
        .text {
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
        }
      }
    }
  }
`;

export default LocationMap;
